<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero"> close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-toolbar flat color="white">
      <v-toolbar-title>Ui Category</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">Create</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.name"
                    label="Name"
                  ></v-text-field>
                  <v-text-field
                    v-model="editedItem.ui_category_key"
                    label="Category Key"
                  ></v-text-field>
                  <v-text-field
                    v-model="editedItem.price"
                    label="Value"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="indexData.datas"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.item.id }}</td>
        <td class="text-xs-center">{{ props.item.name }}</td>
        <td class="text-xs-center">{{ props.item.ui_category_key }}</td>
        <td class="text-xs-center">{{ props.item.price }}</td>
        <td class="justify-center layout px-0">
          <v-icon small class="mr-2" @click="editItem(props.item)">
            edit
          </v-icon>
          <!-- <v-icon
            small
            @click="deleteItem(props.item)"
          >
            delete
          </v-icon> -->
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    dialog: false,
    search: "",
    apiUrl: "ui-category",
    headers: [
      {
        text: "ID",
        align: "center",
        sortable: true,
        value: "id",
      },
      {
        text: "Name",
        align: "center",
        sortable: true,
        value: "name",
      },
      {
        text: "Category Key",
        align: "center",
        sortable: true,
        value: "id",
      },
      {
        text: "Price",
        align: "center",
        sortable: false,
        value: "price",
      },
      { text: "Actions", align: "center", value: "actions" },
    ],
    editedIndex: -1,
    editedItem: {
      name: "",
      price: "",
      ui_category_key: "",
    },
    defaultItem: {
      name: "",
      price: "",
      ui_category_key: "",
    },
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    formTitle() {
      return this.editedIndex === -1 ? "Create" : "Edit";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.$store.dispatch("setIndexData", [this.apiUrl]);
    },

    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },

    editItem(item) {
      this.editedIndex = this.indexData.datas.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.indexData.datas.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.indexData.datas.splice(index, 1);
      this.$store.dispatch("delete", [this.apiUrl, item.id]);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      // console.log(this.editedIndex);
      if (this.editedIndex > -1) {
        this.$store.dispatch("store", [this.apiUrl, this.editedItem]);
      } else {
        this.$store.dispatch("store", [this.apiUrl, this.editedItem]);
      }
      this.close();
      this.initialize();
    },
  },
};
</script>
